import React from 'react';

const AddressCard = () => {
    return (
        <div className="card">
            <div className="card-body">
                <h3 className="card-title">Our Address</h3>
                <p className="card-text">
                Willand Village Hall <br />
                    Gables Road<br />
                    Willand<br />
                    Cullompton<br />
                    EX15 2PL<br />
                </p>
            </div>
        </div>
    )
}

export default AddressCard;


// WEBPACK FOOTER //
// ./src/views/cards/addressCard.js